export const typography = {
    "form": {
        "label": {
            "default": {
                "textAlign": "left",
                "fontSize": "14px",
                "fontWeight": 400,
                "textDecoration": "none",
                "color": "hsla(207, 5%, 56.7%, 1.000)"
            }
        },
        "input": {
            "label": {
                "textAlign": "left",
                "fontSize": "14px",
                "fontWeight": 400,
                "textDecoration": "none",
                "color": "hsla(207, 5%, 56.7%, 1.000)"
            },
            "placeholder": {
                "normal": {
                    "textAlign": "left",
                    "fontStyle": "italic",
                    "fontSize": "16px",
                    "fontWeight": 500,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 46.3%, 1.000)"
                }
            },
            "value": {
                "normal": {
                    "textAlign": "left",
                    "fontSize": "16px",
                    "fontWeight": 500,
                    "lineHeight": "25px",
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 96.9%, 1.000)"
                }
            }
        },
        "button": {
            "secondary": {
                "normal": {
                    "textAlign": "center",
                    "fontSize": "16px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 91.4%, 1.000)"
                },
                "large": {
                    "textAlign": "center",
                    "fontSize": "20px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 91.4%, 1.000)"
                },
                "small": {
                    "textAlign": "center",
                    "fontSize": "14px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 91.4%, 1.000)"
                },
                "xsmall": {
                    "textAlign": "center",
                    "fontSize": "12px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 91.4%, 1.000)"
                }
            }
        }
    },
    "global": {
        "mainMenu": {
            "subItem": {
                "default": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 300,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 100%, 0.549)"
                },
                "hover": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 300,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 100%, 0.800)"
                }
            },
            "subheader": {
                "textAlign": "left",
                "fontSize": "14px",
                "fontWeight": 600,
                "textTransform": "uppercase",
                "letterSpacing": "0.35px",
                "textDecoration": "none",
                "color": "hsla(0, 0%, 100%, 0.545)"
            },
            "identity": {
                "textAlign": "left",
                "fontSize": "12px",
                "fontWeight": 400,
                "textDecoration": "none",
                "color": "hsla(0, 0%, 88.6%, 0.651)"
            },
            "menuItem": {
                "active": {
                    "textAlign": "left",
                    "fontSize": "16px",
                    "fontWeight": 300,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 100%, 1.000)"
                },
                "default": {
                    "textAlign": "left",
                    "fontSize": "16px",
                    "fontWeight": 300,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 100%, 1.000)"
                },
                "hover": {
                    "textAlign": "left",
                    "fontSize": "16px",
                    "fontWeight": 300,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 100%, 1.000)"
                }
            },
            "hidePrompt": {
                "textAlign": "left",
                "fontSize": "14px",
                "fontWeight": 300,
                "textDecoration": "none",
                "color": "hsla(203, 13.2%, 73.3%, 1.000)"
            },
            "sub-MenuItem": {
                "default": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 300,
                    "textDecoration": "none",
                    "color": "hsla(203, 6.6%, 76.1%, 1.000)"
                },
                "active": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 300,
                    "textDecoration": "none",
                    "color": "hsla(203, 6.6%, 76.1%, 1.000)"
                },
                "hover": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 300,
                    "textDecoration": "none",
                    "color": "hsla(203, 6.6%, 76.1%, 1.000)"
                }
            }
        },
        "topBar": {
            "search": {
                "value": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 300,
                    "textDecoration": "none",
                    "color": "hsla(0, 0%, 34.9%, 1.000)"
                }
            }
        }
    },
    "pageHeader": {
        "introduction": {
            "textAlign": "left",
            "fontSize": "14px",
            "fontWeight": 300,
            "lineHeight": "20px",
            "textDecoration": "none",
            "color": "hsla(0, 0%, 85.9%, 1.000)"
        },
        "mainTitle": {
            "textAlign": "left",
            "fontSize": "26px",
            "fontWeight": 600,
            "textDecoration": "none",
            "color": "hsla(208, 17.8%, 85.7%, 1.000)"
        },
        "areaTitle": {
            "textAlign": "left",
            "fontSize": "12px",
            "fontWeight": 400,
            "textDecoration": "none",
            "color": "hsla(205, 7.6%, 69%, 1.000)"
        }
    },
    "styleGuide": {
        "guideTitle": {
            "textAlign": "left",
            "fontSize": "24px",
            "fontWeight": 300,
            "textDecoration": "none",
            "color": "hsla(0, 0%, 48.2%, 1.000)",
            "textTransform": "uppercase",
            "letterSpacing": "0.4px"
        },
        "guideNotes": {
            "textAlign": "left",
            "fontStyle": "italic",
            "fontSize": "14px",
            "fontWeight": 300,
            "lineHeight": "30px",
            "paragraphSpacing": "15px",
            "textDecoration": "none",
            "color": "hsla(0, 0%, 48.2%, 1.000)"
        },
        "itemName": {
            "textAlign": "left",
            "fontSize": "12px",
            "fontWeight": 300,
            "textDecoration": "none",
            "color": "hsla(0, 0%, 22.7%, 1.000)"
        },
        "guideAreaSubtitle": {
            "textAlign": "left",
            "fontSize": "16px",
            "fontWeight": 300,
            "textTransform": "uppercase",
            "textDecoration": "none",
            "color": "hsla(0, 0%, 48.2%, 1.000)"
        },
        "guideAreaTitle": {
            "textAlign": "left",
            "fontSize": "20px",
            "fontWeight": 300,
            "textTransform": "uppercase",
            "textDecoration": "none",
            "color": "hsla(0, 0%, 48.2%, 1.000)"
        }
    },
    "active": {
        "textAlign": "left",
        "fontSize": "14px",
        "fontWeight": 600,
        "textDecoration": "none",
        "color": "hsla(0, 0%, 100%, 0.800)"
    },
    "filters": {
        "filterButton": {
            "default": {
                "textAlign": "left",
                "fontSize": "12px",
                "fontWeight": 400,
                "textDecoration": "none",
                "color": "hsla(0, 0%, 86.3%, 1.000)"
            },
            "active": {
                "textAlign": "left",
                "fontSize": "12px",
                "fontWeight": 400,
                "textDecoration": "none",
                "color": "hsla(0, 0%, 100%, 1.000)"
            },
            "hover": {
                "textAlign": "left",
                "fontSize": "12px",
                "fontWeight": 400,
                "textDecoration": "none",
                "color": "hsla(0, 0%, 100%, 1.000)"
            }
        },
        "searchInput": {
            "placeholder": {
                "textAlign": "left",
                "fontStyle": "italic",
                "fontSize": "12px",
                "fontWeight": 500,
                "textDecoration": "none",
                "color": "hsla(0, 0%, 46.3%, 1.000)"
            },
            "value": {
                "textAlign": "left",
                "fontSize": "12px",
                "fontWeight": 400,
                "textDecoration": "none",
                "color": "hsla(0, 0%, 96.9%, 1.000)"
            }
        }
    },
    "table": {
        "columnData": {
            "firstColumn": {
                "textAlign": "left",
                "fontSize": "14px",
                "fontWeight": 500,
                "textDecoration": "none",
                "color": "hsla(196, 25.3%, 82.2%, 1.000)"
            },
            "lowImportance": {
                "left": {
                    "textAlign": "left",
                    "fontStyle": "italic",
                    "fontSize": "14px",
                    "fontWeight": 500,
                    "textDecoration": "none",
                    "color": "hsla(197, 7.4%, 52.2%, 1.000)"
                },
                "center": {
                    "textAlign": "center",
                    "fontStyle": "italic",
                    "fontSize": "14px",
                    "fontWeight": 500,
                    "textDecoration": "none",
                    "color": "hsla(197, 7.4%, 52.2%, 1.000)"
                },
                "right": {
                    "textAlign": "right",
                    "fontStyle": "italic",
                    "fontSize": "14px",
                    "fontWeight": 500,
                    "textDecoration": "none",
                    "color": "hsla(197, 7.4%, 52.2%, 1.000)"
                }
            },
            "highImportance": {
                "left": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 900,
                    "textDecoration": "none",
                    "color": "hsla(196, 25.3%, 82.2%, 1.000)"
                },
                "right": {
                    "textAlign": "right",
                    "fontSize": "14px",
                    "fontWeight": 900,
                    "textDecoration": "none",
                    "color": "hsla(196, 25.3%, 82.2%, 1.000)"
                },
                "center": {
                    "textAlign": "center",
                    "fontSize": "14px",
                    "fontWeight": 900,
                    "textDecoration": "none",
                    "color": "hsla(196, 25.3%, 82.2%, 1.000)"
                }
            },
            "normalImportance": {
                "right": {
                    "textAlign": "right",
                    "fontSize": "14px",
                    "fontWeight": 500,
                    "textDecoration": "none",
                    "color": "hsla(196, 10.9%, 73.1%, 1.000)"
                },
                "center": {
                    "textAlign": "center",
                    "fontSize": "14px",
                    "fontWeight": 500,
                    "textDecoration": "none",
                    "color": "hsla(196, 10.9%, 73.1%, 1.000)"
                },
                "left": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 500,
                    "textDecoration": "none",
                    "color": "hsla(196, 10.9%, 73.1%, 1.000)"
                }
            },
            "unit": {
                "textAlign": "right",
                "fontStyle": "italic",
                "fontSize": "12px",
                "fontWeight": 500,
                "textDecoration": "none",
                "color": "hsla(193, 9.7%, 63.5%, 1.000)"
            }
        },
        "header": {
            "right": {
                "textAlign": "right",
                "fontSize": "14px",
                "fontWeight": 700,
                "letterSpacing": "0.4px",
                "textDecoration": "none",
                "color": "hsla(204, 10.6%, 81.6%, 1.000)"
            },
            "left": {
                "textAlign": "left",
                "fontSize": "14px",
                "fontWeight": 700,
                "letterSpacing": "0.4px",
                "textDecoration": "none",
                "color": "hsla(204, 10.6%, 81.6%, 1.000)"
            },
            "center": {
                "textAlign": "center",
                "fontSize": "14px",
                "fontWeight": 700,
                "letterSpacing": "0.4px",
                "textDecoration": "none",
                "color": "hsla(204, 10.6%, 81.6%, 1.000)"
            }
        },
        "subHeader": {
            "right": {
                "textAlign": "right",
                "fontSize": "14px",
                "fontWeight": 700,
                "letterSpacing": "0.4px",
                "textDecoration": "none",
                "color": "hsla(204, 10.6%, 81.6%, 1.000)"
            },
            "left": {
                "textAlign": "left",
                "fontSize": "14px",
                "fontWeight": 700,
                "letterSpacing": "0.4px",
                "textDecoration": "none",
                "color": "hsla(204, 10.6%, 81.6%, 1.000)"
            },
            "center": {
                "textAlign": "center",
                "fontSize": "14px",
                "fontWeight": 700,
                "letterSpacing": "0.4px",
                "textDecoration": "none",
                "color": "hsla(204, 10.6%, 81.6%, 1.000)"
            }
        }
    },
    "tables": {
        "groupName": {
            "textAlign": "left",
            "fontSize": "12px",
            "fontWeight": 400,
            "letterSpacing": "0.3px",
            "textDecoration": "none",
            "color": "hsla(0, 0%, 56.5%, 1.000)"
        }
    },
    "meta": {
        "tagList": {
            "item": {
                "normal": {
                    "textAlign": "left",
                    "fontSize": "14px",
                    "fontWeight": 600,
                    "textDecoration": "none",
                    "color": "hsla(200, 3%, 38.8%, 1.000)"
                }
            }
        }
    },
    "searchBar": {
        "placeholder": {
            "textAlign": "left",
            "fontStyle": "italic",
            "fontSize": "14px",
            "fontWeight": 700,
            "textDecoration": "none",
            "color": "hsla(0, 0%, 46.3%, 0.647)"
        }
    },
    "modal": {
        "basicContent": {
            "textAlign": "left",
            "fontSize": "14px",
            "fontWeight": 400,
            "lineHeight": "25px",
            "textDecoration": "none",
            "color": "hsla(0, 0%, 86.3%, 1.000)"
        },
        "title": {
            "textAlign": "left",
            "fontSize": "20px",
            "fontWeight": 400,
            "textShadow": "0px 0px 10px #1a97e959",
            "textDecoration": "none",
            "color": "hsla(0, 0%, 86.3%, 1.000)"
        }
    }
};